import { Box, Flex, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { LinkMessage } from "components/elements/LinkMessage/link-message";
import UserAvatar from "components/elements/UserAvatar";
import WidgetBox from "components/elements/WidgetBox/widget-box";
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "utils/api";

type CompanyBorrowersProps = {
  company: any;
  property?: number;
  entity?: string;
  title?: string;
  maxHeight?: string;
};

const CompanyBorrowers = ({
  company,
  property,
  entity,
  title = "Borrower Accounts",
  maxHeight = "218px",
}: CompanyBorrowersProps) => {
  const { data: accounts = [] } = useQuery({
    queryKey: ["borrowers", company.id, property, entity],
    queryFn: async () => {
      const { users } = await apiRequest("/supabase/borrowers/select", {
        borrower_company: company.id,
        property: property,
        entity: entity,
      });
      return users || [];
    },
  });

  return (
    <WidgetBox title={title} minWidth={"350px"}>
      <Box
        overflowY="auto"
        maxHeight={maxHeight}
        pr={4}
        sx={{
          "&::-webkit-scrollbar": {
            width: "3px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "gray.200",
            borderRadius: "8px",
            height: "150px",
          },
        }}
      >
        <UnorderedList listStyleType="none" p="0px" m="0px">
          {accounts.map((user: any) => (
            <ListItem
              key={user.id}
              _last={{
                borderBottomWidth: "0px",
                pb: "0px",
              }}
              borderBottomColor="gray.50"
              borderBottomWidth="1px"
              py={2}
            >
              <Flex alignItems="center" justifyContent="space-between" gap={4}>
                <UserAvatar size="50px" user={user} />
                <Flex flexDir="column" flex={1}>
                  <Text color="#171B1E" fontWeight="600" fontSize="15px" lineHeight="22px">
                    {user.first_name} {user.last_name}
                  </Text>
                  <Text fontSize="13px">{user.role?.name}</Text>
                </Flex>
                <LinkMessage borrowerId={user.id} />
              </Flex>
            </ListItem>
          ))}
        </UnorderedList>
      </Box>
    </WidgetBox>
  );
};

export default CompanyBorrowers;
